import localforage from 'localforage'

// Key is also defined in use-clear-cache-on-version-change.tsx
const APP_VERSION_KEY = 'APP_VERSION'

/**
 * Clears all caches except for the application version key in localStorage.
 * This allows to use the app version to force a cache refresh if the app version has changed.
 */
export const clearCacheExceptAppVersion = (): void => {
  clearLocalStorageExcept([APP_VERSION_KEY])
  localforage.clear()
  sessionStorage.clear()
}

const clearLocalStorageExcept = (keysToKeep: string[]): void => {
  Object.keys(localStorage).forEach(key => {
    if (!keysToKeep.includes(key)) {
      localStorage.removeItem(key)
    }
  })
}
